'use client'

import { getJobDataAPI } from "@/api-config/get";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const JobModal = ({ jobData, onClose }) => {


    const [loader, setLoader] = useState(true)
    const [jobFullData, setJobFullData] = useState(null)
    const dispatch = useDispatch()

    useEffect(() => {

        setLoader(true)
        dispatch(getJobDataAPI(jobData?.requisitionId, setJobFullData, setLoader))

        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <div className="fixed inset-0 bg-white bg-opacity-80 flex items-center justify-center z-[60]">
            <div className="bg-white relative rounded-[50px] w-full max-w-3xl sm:p-5 p-8 shadow-2xl mx-8 flex flex-col justify-center md:justify-start max-h-[90vh] overflow-y-auto">
                <div onClick={onClose} className="xs:right-4 xs:top-4 absolute z-30 top-8 right-8 rotate-45 border-2 border-black rounded-full p-[5px] cursor-pointer opacity-70">
                    <img src="/images/close.svg" alt="close modal" />
                </div>
                <div className="w-full font-semibold text-sm text-[#EB532E] mb-1">
                    {(jobFullData || jobData)?.skillCategoryResponse?.length ? (jobFullData || jobData)?.skillCategoryResponse[0]?.name : (jobFullData || jobData)?.jobTitle}
                </div>
                <div className="w-full mb-2 font-semibold leading-normal text-2xl md:text-lg">
                    {(jobFullData || jobData)?.jobTitle}
                </div>
                <div className='max-h-[18rem] overflow-y-auto pr-3'>
                    {loader ? (
                        <div className="animate-pulse flex flex-col gap-4">
                            <div className="h-4 rounded w-28 bg-gray-300"></div>
                            <div className="h-4 rounded w-60 bg-gray-300"></div>
                            {[...Array(5)].map((_, i) => (
                                <div key={i} className="h-4 rounded w-full bg-gray-300"></div>
                            ))}
                        </div>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: (jobFullData || jobData)?.jobDescription }} />
                    )}
                </div>
                <div className="flex items-start w-full gap-6 py-4">
                    <div className="relative w-fit flex gap-2.5">
                        <svg className="stroke-[#667085] group-hover:stroke-white transition-all duration-300" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.99998 10.4166C9.38069 10.4166 10.5 9.29734 10.5 7.91663C10.5 6.53591 9.38069 5.41663 7.99998 5.41663C6.61927 5.41663 5.49998 6.53591 5.49998 7.91663C5.49998 9.29734 6.61927 10.4166 7.99998 10.4166Z" stroke="current" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M7.99998 18.3333C9.66665 15 14.6666 12.8485 14.6666 8.33329C14.6666 4.65139 11.6819 1.66663 7.99998 1.66663C4.31808 1.66663 1.33331 4.65139 1.33331 8.33329C1.33331 12.8485 6.33331 15 7.99998 18.3333Z" stroke="current" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        <div className="relative w-fit font-semibold text-base text-secondary group-hover:text-white transition-all duration-300" id="mj-location">{(jobFullData || jobData)?.location}</div>
                    </div>
                    <div className="relative w-fit flex gap-2.5">
                        <svg className="stroke-[#667085] group-hover:stroke-white transition-all duration-300" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4.99996V9.99996L13.3334 11.6666M18.3334 9.99996C18.3334 14.6023 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6023 1.66669 9.99996C1.66669 5.39759 5.39765 1.66663 10 1.66663C14.6024 1.66663 18.3334 5.39759 18.3334 9.99996Z" stroke="current" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        <div className="relative w-fit font-semibold text-base text-secondary group-hover:text-white transition-all duration-300" id="mj-schedule">{(jobFullData || jobData)?.minExp}</div>
                    </div>
                </div>
                <div className="relative w-full">
                    <div className="relative w-full py-2.5 text-center lg:text-left lg:text-center">
                        <a href={(jobFullData || jobData)?.jobUrl} target="_blank" className="bg-[#EB532E] relative text-white py-3.5 px-6 rounded-full hover:underline transition-all duration-300 hover:bg-[#b33313] font-semibold">Register and Apply</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobModal;